<!-- <div class="is-hidden-mobile"> -->
  <div class="caddie explorer">
    <app-cancernet-panel [drug]="explorerData.cancernetDrug" [(show)]="explorerData.showCancernetModal" (closeEvent)="explorerData.closeCancernetModal()"></app-cancernet-panel>
    <app-sidebar></app-sidebar>
    <div class="caddie right-window" id="loadingOverlayTarget">
      <div [hidden]="explorerData.selectedAnalysisToken">
        <!-- display network information if user has not clicked "don't show again" -->
        <app-explorer-network-information></app-explorer-network-information>
        <app-network [networkType]="'basic'" [target]="'none'"></app-network>
      </div>
      <div class="analysis-view" *ngIf="explorerData.selectedAnalysisToken"[ngClass]="{analysisFullscreen: explorerData.analysisFullscreen}" >
        <app-analysis-panel
          [(token)]="explorerData.selectedAnalysisToken"
          (showDetailsChange)="
            explorerData.selectedWrapper = $event;
            explorerData.selectedWrapperComorbidities =
              explorerData.selectedWrapper
                ? $event.comorbidities
                : null;
            explorerData.selectedWrapperCancerTypes =
              explorerData.selectedWrapper
                ? $event.cancerTypes
                : null
          "
          (visibleTab)="visibleAnalysisTab = $event"
        >
        </app-analysis-panel>
        <!-- A modal to display the caCanceRxncernet information for one drug -->
      </div>
    </div>
  </div>
<!-- </div> -->
<!-- <div class="is-hidden-tablet mobile-fallback">
  Sorry, caddie is not available for mobile phones. To find information about
  caddie, please check the <a routerLink="/about">About</a> page or visit this
  page with another device with a larger screen.
</div> -->
